// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
* {
  font-family: "URW DIN Arabic";
}
body:lang(en),
*:lang(en) {
  font-family: "URW DIN Arabic";
}

body{
  overflow-x: hidden;
}
html {
  scroll-behavior: smooth;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB","sourcesContent":["body,\n* {\n  font-family: \"URW DIN Arabic\";\n}\nbody:lang(en),\n*:lang(en) {\n  font-family: \"URW DIN Arabic\";\n}\n\nbody{\n  overflow-x: hidden;\n}\nhtml {\n  scroll-behavior: smooth;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
